import { EditProjectContextProps } from "../../EditProjectContext";
import { getAllActiveLtlRoutings } from "./GetAllActiveLtlRoutings";
import { getSupplierTransitTime } from "./GetSupplierTransitTime";
import { areRoutesChanged } from "./LtlTabTable/AreRoutesChanged";

export async function setAllActiveLtlRoutings(
  editProjectContext: EditProjectContextProps,
  spdrIds: (number | undefined)[] | undefined,
  pdsrIds: (number | undefined)[] | undefined
) {
  let responseLtlPipelines = await getAllActiveLtlRoutings(
    editProjectContext,
    spdrIds,
    pdsrIds
  );
  const { project, setProject } = editProjectContext;

  if (!responseLtlPipelines) {
    return false;
  }

  responseLtlPipelines = responseLtlPipelines.filter(
    (x) =>
      !areRoutesChanged(x.SpdrId, project.FTLRoutes, project.TemplateFTLRoutes)
  );

  if (responseLtlPipelines.length === 0) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const responseLtlPipeline of responseLtlPipelines) {
    const ltlPipeline =
      responseLtlPipeline?.SpdrId ?? -1 > 0
        ? project?.ltlPipelines?.find(
            (item) => item.SpdrId === responseLtlPipeline.SpdrId
          )
        : project?.ltlPipelines?.find(
            (item) => item.PdsrId === responseLtlPipeline.PdsrId
          );

    if (!ltlPipeline) {
      // eslint-disable-next-line no-continue
      continue;
    }

    ltlPipeline.routing = responseLtlPipeline.routing;
    ltlPipeline.IsFinished = responseLtlPipeline.IsFinished;
    ltlPipeline.SupplierTransitTime = getSupplierTransitTime(
      responseLtlPipeline.routing,
      responseLtlPipeline.TTAdjustment
    ).toString();
  }
  setProject({ ...project });
  return true;
}
